import ProtoTypes from 'prop-types';
import Divider from "@mui/material/Divider";

export function CustomDivider(props) {
    const { theme } = props;
    const isLight = theme === 'light';

    let dividerColor = isLight ? 'rgba(216, 216, 216, 1)' : 'rgba(247, 247, 247, 1)';
    dividerColor = '1px solid '.concat(dividerColor);

  return (
    <Divider
      sx={{
        marginBottom: 6,
        borderTop: dividerColor
      }}
    ></Divider>
  );
}

CustomDivider.propTypes = {
    theme: ProtoTypes.string,
}

CustomDivider.defaultProps = {
    theme: 'light'
}